/* Account Addresses — inline add / edit / remove / set-default.
 *
 * customer.* is read-only in the theme (new passwordless customer accounts),
 * so all writes go to the Velvety App Proxy Worker at /apps/velvety/account/address
 * which calls the Admin API (customerAddressCreate/Update/Delete). Shopify signs
 * the request with a verified logged_in_customer_id.
 */
(function () {
  var root = document.querySelector('[data-velvety-addresses]');
  var dialog = document.querySelector('[data-address-dialog]');
  if (!root || !dialog) return;

  var form = dialog.querySelector('[data-address-form]');
  var title = dialog.querySelector('[data-address-form-title]');
  var idInput = dialog.querySelector('[data-address-id]');
  var formError = dialog.querySelector('[data-address-form-error]');
  var saveBtn = dialog.querySelector('[data-address-save]');
  var alertBox = root.querySelector('[data-address-alert]');

  var FIELDS = ['first_name', 'last_name', 'company', 'address1', 'address2', 'city', 'province', 'country', 'zip', 'phone'];

  function field(name) { return form.querySelector('[name="' + name + '"]'); }

  function showAlert(type, msg) {
    if (!alertBox) return;
    alertBox.textContent = msg;
    alertBox.hidden = false;
    alertBox.className = 'velvety-addresses__alert velvety-addresses__alert--' + type;
  }
  function showFormError(msg) {
    if (!formError) return;
    formError.textContent = msg;
    formError.hidden = false;
  }
  function clearFormError() {
    if (!formError) return;
    formError.textContent = '';
    formError.hidden = true;
  }

  function openDialog(mode, data) {
    clearFormError();
    data = data || {};
    title.textContent = mode === 'edit' ? 'Edit address' : 'Add address';
    idInput.value = data.id || '';
    FIELDS.forEach(function (f) {
      var el = field(f);
      if (el) el.value = data[f] || '';
    });
    var def = field('set_default') || dialog.querySelector('[data-address-default-check]');
    if (def) def.checked = mode === 'edit' ? (data.isDefault === true) : false;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }
  function closeDialog() {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function cardData(card) {
    return {
      id: card.getAttribute('data-id'),
      first_name: card.getAttribute('data-first-name'),
      last_name: card.getAttribute('data-last-name'),
      company: card.getAttribute('data-company'),
      address1: card.getAttribute('data-address1'),
      address2: card.getAttribute('data-address2'),
      city: card.getAttribute('data-city'),
      province: card.getAttribute('data-province'),
      country: card.getAttribute('data-country'),
      zip: card.getAttribute('data-zip'),
      phone: card.getAttribute('data-phone'),
      isDefault: card.getAttribute('data-default') === 'true'
    };
  }

  function post(payload) {
    return fetch('/apps/velvety/account/address', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  /* Open add */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-address-add]');
    if (t) { e.preventDefault(); openDialog('add'); return; }

    var card = e.target.closest('[data-address-card]');
    if (!card) return;
    var data = cardData(card);

    if (e.target.closest('[data-address-edit]')) {
      e.preventDefault();
      openDialog('edit', data);
    } else if (e.target.closest('[data-address-delete]')) {
      e.preventDefault();
      if (!window.confirm('Remove this address?')) return;
      post({ action: 'delete', address_id: data.id })
        .then(function (res) {
          if (res && res.ok) { window.location.reload(); }
          else { showAlert('error', (res && res.message) || 'Could not remove the address.'); }
        })
        .catch(function () { showAlert('error', 'Network error. Please try again.'); });
    } else if (e.target.closest('[data-address-default]')) {
      e.preventDefault();
      var payload = { action: 'update', address_id: data.id, set_default: true };
      FIELDS.forEach(function (f) { payload[f] = data[f] || ''; });
      post(payload)
        .then(function (res) {
          if (res && res.ok) { window.location.reload(); }
          else { showAlert('error', (res && res.message) || 'Could not set the default address.'); }
        })
        .catch(function () { showAlert('error', 'Network error. Please try again.'); });
    }
  });

  /* Cancel / close */
  dialog.addEventListener('click', function (e) {
    if (e.target.closest('[data-address-cancel]')) { e.preventDefault(); closeDialog(); }
  });

  /* Submit add/edit */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearFormError();
    var addr1 = (field('address1').value || '').trim();
    var city = (field('city').value || '').trim();
    var country = (field('country').value || '').trim();
    if (!addr1 || !city || !country) {
      showFormError('Please fill in the address, city and country.');
      return;
    }
    var id = (idInput.value || '').trim();
    var payload = { action: id ? 'update' : 'create' };
    if (id) payload.address_id = id;
    FIELDS.forEach(function (f) {
      var el = field(f);
      payload[f] = el ? (el.value || '').trim() : '';
    });
    var def = field('set_default') || dialog.querySelector('[data-address-default-check]');
    payload.set_default = !!(def && def.checked);

    var prev = saveBtn ? saveBtn.textContent : '';
    if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = 'SAVING…'; }

    post(payload)
      .then(function (res) {
        if (res && res.ok) { window.location.reload(); }
        else { showFormError((res && res.message) || 'Could not save the address.'); }
      })
      .catch(function () { showFormError('Network error. Please try again.'); })
      .finally(function () { if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = prev; } });
  });
})();
